interface InfoSidebarDetailProps {
    title?: string;
    description?: string;
    itemCount?: number;
    collectionName?: string;
    icon?: 'info' | 'database' | 'file' | 'users' | 'settings';
    defaultOpen?: boolean;
}

export function InfoSidebarDetail({
    description,
    itemCount,
    collectionName,
}: InfoSidebarDetailProps) {
    return (
        <>
            <div className="space-y-4 text-sm">
                {collectionName && (
                    <div>
                        <span className="text-muted-foreground">Collection</span>
                        <p className="font-medium">{collectionName}</p>
                    </div>
                )}

                {description && (
                    <div>
                        <span className="text-muted-foreground">Description</span>
                        <p className="text-foreground">{description}</p>
                    </div>
                )}

                {itemCount !== undefined && (
                    <div>
                        <span className="text-muted-foreground">Items</span>
                        <p className="font-medium">{itemCount.toLocaleString()}</p>
                    </div>
                )}

                {!description && !collectionName && itemCount === undefined && (
                    <p className="text-muted-foreground italic">
                        No additional information available.
                    </p>
                )}
            </div>
        </>
    );
}
